var Segment = /** @class */ (function () {
    function Segment(id, name, url, global) {
        this.id = id;
        this.name = name;
        this.url = url;
        this.global = global;
    }
    Segment.prototype.getId = function () {
        return this.id;
    };
    Segment.prototype.isGlobal = function () {
        return this.global;
    };
    Segment.prototype.getName = function () {
        return this.name;
    };
    Segment.prototype.getUrl = function () {
        return this.url;
    };
    Segment.prototype.getResponseItem = function () {
        return {
            id: this.getId(),
            name: this.getName(),
            url: this.getUrl(),
            global: this.isGlobal() ? 1 : 0
        };
    };
    return Segment;
}());
export default Segment;
